import React from "react";
import { useTranslation } from "react-i18next";
import { RecentPlaceEntry } from "../../hooks/useRecentPlaces";

export interface RecentPlacesProps {
  recents: RecentPlaceEntry[];
  onSelect: (recent: RecentPlaceEntry) => void;
  /** Keeps focus on the input while a recent place is tapped. */
  onMouseDown: (event: React.MouseEvent) => void;
}

// Recent places fill whichever location field is active.
const RecentPlaces: React.FC<RecentPlacesProps> = ({ recents, onSelect, onMouseDown }) => {
  const { t } = useTranslation("hailing");
  return (
    <>
      <div className="mt-[22px] text-[13px] font-medium text-[#6B7075]">
        {t("steps.where.recent")}
      </div>
      <div>
        {recents.map((r) => (
          <button
            key={r.placeId}
            type="button"
            onMouseDown={onMouseDown}
            onClick={() => onSelect(r)}
            className="flex w-full items-center gap-3.5 border-b border-[#E3E4E5] py-3 text-left hover:bg-black/[0.03] focus-visible:bg-black/[0.03] focus-visible:outline-none"
          >
            <span className="font-material-symbols shrink-0 text-[22px] leading-none text-[#3A4045]">
              history
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-[15px] font-medium text-ink-100">
                {r.displayName}
              </span>
              <span className="mt-0.5 block truncate text-[12px] text-[#6B7075]">
                {r.formattedAddress}
              </span>
            </span>
          </button>
        ))}
      </div>
    </>
  );
};

export default RecentPlaces;
